

const SignupFormHeader = ({headerText, stepCount, completionPercentage}) => {
    return (
        <div className="w-full">
            <div className="text-center">
                <div className="text-2xl font-semibold">
                    {headerText}
                </div>
            </div>
            
            <div className="w-full my-5">
                <div className="flex items-center justify-end">
                    <span className="text-ep-primary-400">Step {stepCount}&nbsp;</span> of 2
                </div>
                <div className="w-full h-1 rounded-md bg-[#E2E6F9] mt-4">
                    <div style={{width: `${completionPercentage}%`}} className="h-full rounded-md bg-ep-primary-400"></div>
                </div>
            </div>
        </div>
    )
}

export default SignupFormHeader;